import { render, staticRenderFns } from "./addLearningCentre.vue?vue&type=template&id=8d4781c4&scoped=true&"
import script from "./addLearningCentre.vue?vue&type=script&lang=js&"
export * from "./addLearningCentre.vue?vue&type=script&lang=js&"
import style0 from "./addLearningCentre.vue?vue&type=style&index=0&id=8d4781c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4781c4",
  null
  
)

export default component.exports